<div class="cet-custom-modal-container" [class.show]="showModal">
  <div class="cet-backdrop" (click)="!static && hide()"></div>
  <div class="cet-modal">
    <div class="header">
      <span #headerTitle><ng-content select="[header]"></ng-content></span>
      <span *ngIf="headerTitle.children.length != 0" type="button" (click)="hide()" class="closeBtn">
        <svg width="24px" height="24px">
          <use xlink:href="assets/images/icons.svg#x-thick"></use>
        </svg>
        <span class="visually-hidden">Close Modal</span>
      </span>
    </div>
    <div class="body">
      <ng-content select="[body]"></ng-content>
    </div>
    <div class="footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
